<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <h3>{{ $t('Conversaciones') }}</h3>
      </v-card-title>

      <v-toolbar extension-height="130px" color="white" class="pb-0 mb-0">
        <v-dialog v-model="threadForm" persistent max-width="964px">
          <v-btn slot="activator" color="primary">
            {{ $t('Nueva Conversación') }}
          </v-btn>
          <admin-thread-form
            :customers="customers ? customers : []"
            @created="addThread"
            @closeForm="threadForm = false"
          ></admin-thread-form>
        </v-dialog>
        <v-btn @click="restoreFilters()" color="secondary">
          {{ $t('Restaurar filtros') }}
        </v-btn>
        <og-saved-filters
          scope="admin_conversations"
          :current="savedFiltersState"
          @apply="applySavedFilters"
          @saved="notify('success', $event)"
          @error="notify('error', $event)"
        />
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          solo
          color="primary"
          append-icon="mdi-magnify"
          :label="$t('Search')"
          @click:append="searchThread"
          single-line
          hide-details
        ></v-text-field>
        <v-switch
          class="ml-3 og-search-messages"
          color="primary"
          v-model="searchMessages"
          :label="$t('Buscar en mensajes')"
          hide-details
        ></v-switch>

        <v-layout
          align-center
          justify-end
          row
          fill-height
          wrap
          slot="extension"
          class="white--text"
        >
          <v-flex xs6>
            <og-user-select multiple v-model="customers"></og-user-select>
          </v-flex>
          <v-flex xs3>
            <v-select
              solo
              class="ml-3"
              color="primary"
              v-model="myCustomers"
              item-text="text"
              item-value="value"
              :items="[
                { text: 'No filtrar', value: false },
                { text: 'Sólo mis clientes', value: true },
              ]"
              row
            ></v-select>
          </v-flex>

          <v-flex xs3>
            <clavedat-selector
              v-model="clavedat"
              multiple
              label="Empresas"
              class="ml-3"
              solo
            ></clavedat-selector>
          </v-flex>

          <v-flex grow class="og-select-category">
            <category-select
              solo
              class="mr-3"
              color="primary"
              v-model="categories"
            ></category-select>
          </v-flex>
          <v-flex class="og-select-status">
            <v-select
              solo
              color="primary"
              v-model="status"
              item-text="text"
              item-value="value"
              :items="[
                { text: 'Todas', value: null },
                { text: 'Activas', value: 'active' },
                { text: 'Pendientes', value: 'pending' },
                { text: 'Cerradas', value: 'closed' },
              ]"
              row
            ></v-select>
          </v-flex>
          <v-flex xs2>
            <v-select
              solo
              class="ml-3"
              color="primary"
              v-model="read"
              item-text="text"
              item-value="value"
              :items="[
                { text: 'Leídas + No leídas', value: null },
                { text: 'Leídas', value: 'true' },
                { text: 'No leídas', value: 'false' },
              ]"
              row
            ></v-select>
          </v-flex>
          <v-flex shrink>
            <v-switch class="ml-3" v-model="unreadMessages" :label="$t('Sin leer')"></v-switch>
          </v-flex>
          <v-flex shrink>
            <v-switch class="ml-3" v-model="premiumUsers" :label="$t('Premium')"></v-switch>
          </v-flex>
          <v-flex shrink>
            <v-switch
              class="ml-3"
              color="deep-purple"
              v-model="toManage"
              :label="$t('Por gestionar')"
            ></v-switch>
          </v-flex>

          <!-- <div class="mx-3">
                        <v-checkbox  color="primary" :label="$t('Activas')" v-model="active"></v-checkbox>
                    </div>
                    <div class="mx-3">
                        <v-checkbox  color="primary" :label="$t('Cerradas')" v-model="closed"></v-checkbox>
          </div>-->
        </v-layout>
      </v-toolbar>
      <v-alert :value="searchMessages" type="info" outline class="my-1 mx-3 py-1">
        {{
          $t(
            'En los mensajes se buscan palabras enteras o su comienzo, de al menos 3 letras: «factu» encuentra «factura», pero «tura» no.',
          )
        }}
      </v-alert>
      <v-progress-linear
        v-if="loading"
        class="py-0 my-0"
        height="3"
        :indeterminate="loading"
      ></v-progress-linear>

      <v-alert
        :value="showPendingBanner"
        type="warning"
        outline
        class="og-pending-banner my-2 mx-3"
      >
        <v-layout align-center row wrap>
          <span>
            {{
              pendingCount === 1
                ? 'Hay 1 conversación pendiente con los filtros aplicados'
                : `Hay ${pendingCount} conversaciones pendientes con los filtros aplicados`
            }}
          </span>
          <v-spacer></v-spacer>
          <v-btn small color="warning" @click="status = 'pending'">
            {{ $t('Ver pendientes') }}
          </v-btn>
        </v-layout>
      </v-alert>

      <v-list three-line class="og-thread-list">
        <template v-for="thread in threads">
          <v-list-tile
            :key="thread.id"
            avatar
            @click="threadDetail(thread.id)"
            v-bind:class="{ 'unread-thread': !thread.read, 'to-manage-thread': thread.to_manage }"
          >
            <v-list-tile-action mr-2>
              <v-badge
                v-if="thread.unreaded_messages"
                size="24"
                color="secondary"
                class="admin-thread-notification-badge"
                overlap
              >
                <span slot="badge">{{ thread.unreaded_messages }}</span>
                <user-avatar :size="40" no-name :user="thread.user"></user-avatar>
              </v-badge>
              <user-avatar v-else :size="40" no-name :user="thread.user"></user-avatar>

              <!-- <user-avatar :size="40" no-name :user="thread.user"></user-avatar> -->
              <!-- <category-icon x-large :category="thread.category"></category-icon> -->
            </v-list-tile-action>
            <v-list-tile-content>
              <div class="og-thread-content">
                <div>
                  <b v-if="!!thread && !!thread.user && !!thread.user.name">
                    {{ thread.user.name }}
                    <template v-if="thread.user.clavedats && thread.user.clavedats.length">
                      <span class="ml-2">
                        [
                        <template v-for="(clavedat, i) in thread.user.clavedats">
                          <span :key="`cli-more-${i}`" v-if="i > 0" class="ml-1 mr-1">-</span>
                          <span :key="`cli-${i}`">{{ clavedat }}</span>
                        </template>
                        ]
                      </span>
                    </template>
                    <v-icon
                      v-if="!!thread && !!thread.user && !!thread.user.premium"
                      class="ml-2"
                      color="secondary"
                    >
                      mdi-star-circle
                    </v-icon>
                    <v-tooltip
                      top
                      v-if="
                        !!thread &&
                          !!thread.user &&
                          !!thread.user.non_payment &&
                          !thread.user.non_payment_blocked
                      "
                    >
                      <v-icon slot="activator" class="ml-2" color="warning">
                        mdi-skull-crossbones
                      </v-icon>
                      <span>{{ $t('Cliente con deudas pendientes de pago') }}</span>
                    </v-tooltip>
                    <v-tooltip
                      top
                      v-if="
                        !!thread &&
                          !!thread.user &&
                          !!thread.user.non_payment &&
                          !!thread.user.non_payment_blocked
                      "
                    >
                      <v-icon slot="activator" class="ml-2" color="error">
                        mdi-skull-crossbones
                      </v-icon>
                      <span>{{ $t('Cliente bloqueado por impago') }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="!!thread && !!thread.user && !thread.user.seguimiento">
                      <v-icon slot="activator" class="ml-2" color="warning">
                        mdi-alert-circle
                      </v-icon>
                      <span>{{ $t('Tiene tareas de activación pendientes') }}</span>
                    </v-tooltip>
                    <fiscal-data-quick-view
                      v-if="!!thread.user.id"
                      :user-id="thread.user.id"
                    ></fiscal-data-quick-view>
                  </b>
                  <b v-else>{{ $t('Usuario desconocido') }}</b>

                  <v-list-tile-title>{{ thread.title }}</v-list-tile-title>

                  <v-list-tile-sub-title>
                    <message-excerpt :message="lastComment(thread)"></message-excerpt>
                  </v-list-tile-sub-title>
                </div>
                <div>
                  <v-chip v-if="!!thread && !!thread.company_name">
                    {{ thread.company_name }}
                  </v-chip>
                </div>
              </div>
            </v-list-tile-content>
            <v-list-tile-action class="mr-2">
              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icon
                  flat
                  :loading="togglingToManage === thread.id"
                  @click.stop="toggleToManage(thread)"
                >
                  <v-icon :color="thread.to_manage ? 'deep-purple' : 'grey lighten-1'">
                    {{ thread.to_manage ? 'mdi-flag' : 'mdi-flag-outline' }}
                  </v-icon>
                </v-btn>
                <span>
                  {{
                    thread.to_manage ? $t('Quitar «Por gestionar»') : $t('Marcar «Por gestionar»')
                  }}
                </span>
              </v-tooltip>
            </v-list-tile-action>
            <v-list-tile-action class="mr-3">
              <v-badge color="primary" overlap>
                <span slot="badge">{{ thread.messages_count }}</span>
                <v-icon color="grey">mdi-message-text</v-icon>
              </v-badge>
            </v-list-tile-action>
            <v-list-tile-action>
              <status-widget :status="thread.status"></status-widget>
            </v-list-tile-action>
            <v-list-tile-action>
              <v-btn icon flat>
                <v-icon color="primary">mdi-chevron-right</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider :key="'divider-' + thread.id"></v-divider>
        </template>
      </v-list>
      <div class="text-xs-center">
        <v-pagination v-model="page" :length="pagination.last_page"></v-pagination>
      </div>
    </v-card>
    <v-snackbar
      v-model="notification.snackbar"
      :bottom="notification.y === 'bottom'"
      :color="notification.color"
      :left="notification.x === 'left'"
      :multi-line="notification.mode === 'multi-line'"
      :right="notification.x === 'right'"
      :timeout="notification.timeout"
      :top="notification.y === 'top'"
      :vertical="notification.mode === 'vertical'"
    >
      {{ notification.text }}

      <v-btn dark text @click="notification.snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-flex>
</template>

<script>
import axios from 'axios';
import StatusWidget from '@/components/commons/StatusWidget.vue';
import ThreadAPI from '@/modules/myconsultant/services/thread.js';
import AdminConversationsAPI from '../services/adminConversationsAPI.js';
import MessageExcerpt from '@/components/commons/MessageExcerpt.vue';
import CategorySelect from '@/components/commons/CategorySelect.vue';
import OgUserSelect from '@/components/commons/form/inputs/OgUserSelect.vue';
import UserAvatar from '@/components/commons/UserAvatar.vue';
import AdminThreadForm from './AdminThreadForm.vue';
import ClavedatSelector from '@/components/commons/form/inputs/ClavedatSelector.vue';
import FiscalDataQuickView from '@/modules/admin/aplifisa/components/FiscalDataQuickView.vue';
import OgSavedFilters from '@/components/commons/OgSavedFilters.vue';

export default {
  components: {
    StatusWidget,
    MessageExcerpt,
    CategorySelect,
    OgUserSelect,
    UserAvatar,
    AdminThreadForm,
    ClavedatSelector,
    FiscalDataQuickView,
    OgSavedFilters,
  },
  data() {
    return {
      threadForm: false,
      // customers: [],
      // page: 1,
      // search: "",
      // status: "active",
      // categories: [],
      threads: [],
      loading: true,
      togglingToManage: null,
      pendingCount: 0,
      // myCustomers: true,
      // params: {
      //   search: {
      //     search: ""
      //   },
      //   myCustomers: true,
      //   status: "active",
      //   users: [],
      //   categories: null,
      //   page: 1,
      //   where: {}
      // },
      pagination: {
        current_page: 1,
        from: 1,
        last_page: null,
        per_page: 15,
        to: null,
        total: null,
      },
      notification: {
        color: '',
        mode: 'multi-line',
        snackbar: false,
        text: '',
        timeout: 6000,
        x: '',
        y: 'top',
      },
    };
  },
  computed: {
    customers: {
      get() {
        return this.$store.getters['adminConv/customers'];
      },
      set(value) {
        this.$store.commit('adminConv/customers', value);
      },
    },
    page: {
      get() {
        return this.$store.getters['adminConv/page'];
      },
      set(value) {
        this.$store.commit('adminConv/page', value);
      },
    },
    search: {
      get() {
        return this.$store.getters['adminConv/search'];
      },
      set(value) {
        this.$store.commit('adminConv/search', value);
      },
    },
    searchMessages: {
      get() {
        return this.$store.getters['adminConv/searchMessages'];
      },
      set(value) {
        this.$store.commit('adminConv/searchMessages', value);
      },
    },
    status: {
      get() {
        return this.$store.getters['adminConv/status'];
      },
      set(value) {
        this.$store.commit('adminConv/status', value);
      },
    },
    categories: {
      get() {
        return this.$store.getters['adminConv/categories'];
      },
      set(value) {
        this.$store.commit('adminConv/categories', value);
      },
    },
    myCustomers: {
      get() {
        return this.$store.getters['adminConv/myCustomers'];
      },
      set(value) {
        this.$store.commit('adminConv/myCustomers', value);
      },
    },
    params: {
      get() {
        return this.$store.getters['adminConv/params'];
      },
      set(value) {
        this.$store.commit('adminConv/params', value);
      },
    },
    read: {
      get() {
        return this.$store.getters['adminConv/read'];
      },
      set(value) {
        this.$store.commit('adminConv/read', value);
      },
    },
    unreadMessages: {
      get() {
        return this.$store.getters['adminConv/unreadMessages'];
      },
      set(value) {
        this.$store.commit('adminConv/unreadMessages', value);
      },
    },
    premiumUsers: {
      get() {
        return this.$store.getters['adminConv/premiumUsers'];
      },
      set(value) {
        this.$store.commit('adminConv/premiumUsers', value);
      },
    },
    toManage: {
      get() {
        return this.$store.getters['adminConv/toManage'];
      },
      set(value) {
        this.$store.commit('adminConv/toManage', value);
      },
    },
    savedFiltersState() {
      return this.$store.getters['adminConv/savedFilters'];
    },
    showPendingBanner() {
      return this.status !== 'pending' && this.pendingCount > 0;
    },
    clavedat: {
      get() {
        return this.$store.getters['adminConv/clavedat'];
      },
      set(value) {
        this.$store.commit('adminConv/clavedat', value);
      },
    },
  },
  created() {
    this.searchRequestId = 0;
    this.searchScheduled = false;
    this.cancelSearch = null;
    // No reactivo: solo descarta respuestas de peticiones obsoletas
    this.pendingRequest = 0;
  },
  async mounted() {
    // if (
    //   this.$store.state.hasOwnProperty("user") &&
    //   this.$store.state.user &&
    //   this.$store.state.user.hasOwnProperty("consultant_profile") &&
    //   this.$store.state.user.consultant_profile &&
    //   this.$store.state.user.consultant_profile.hasOwnProperty("categories") &&
    //   this.$store.state.user.consultant_profile.categories
    // ) {
    //   const categories = [];
    //   this.$store.state.user.consultant_profile.categories.forEach(element => {
    //     categories.push(element.name);
    //   });
    //   this.$store.commit('adminConv/categories', categories);
    //   console.log({ CATEGORIES: this.categories });
    //   // this.params.categories = this.categories;
    // }
    this.searchThread();
  },
  methods: {
    searchThread: function() {
      // Los cambios de filtro que llegan juntos (p. ej. «Restaurar filtros») lanzan una sola petición
      if (this.searchScheduled) {
        return;
      }
      this.searchScheduled = true;
      this.$nextTick(() => {
        this.searchScheduled = false;
        this.fetchThreads();
        this.loadPendingCount();
      });
    },

    // Cuenta las conversaciones pendientes con los mismos filtros, salvo el de estado
    loadPendingCount: function() {
      if (this.status === 'pending') {
        this.pendingCount = 0;
        return;
      }
      const request = ++this.pendingRequest;
      // Solo hace falta el total: una fila por página
      const params = Object.assign({}, this.params, { status: 'pending', page: 1, per_page: 1 });
      AdminConversationsAPI.list(params)
        .then(response => {
          if (request === this.pendingRequest) {
            this.pendingCount = response.data.meta.total || 0;
          }
        })
        .catch(() => {
          if (request === this.pendingRequest) {
            this.pendingCount = 0;
          }
        });
    },
    fetchThreads: function() {
      // Solo vale la respuesta de la última petición: las anteriores se cancelan y, si llegan, se descartan
      if (this.cancelSearch) {
        this.cancelSearch();
      }
      const requestId = ++this.searchRequestId;
      this.loading = true;
      const cancelToken = new axios.CancelToken(cancel => {
        this.cancelSearch = cancel;
      });
      AdminConversationsAPI.list(this.params, { cancelToken })
        .then(response => {
          if (requestId !== this.searchRequestId) {
            return;
          }
          this.threads = response.data.data;
          this.pagination = response.data.meta;
        })
        .catch(() => {})
        .then(() => {
          if (requestId === this.searchRequestId) {
            this.loading = false;
          }
        });
    },

    threadDetail: function(thread) {
      this.$router.push({
        name: 'threadAdminDetail',
        params: { thread: thread },
      });
      // console.log('clicked');
    },
    lastComment: function(thread) {
      return thread.last_message;
    },
    searchIfStop: function(val) {
      if (val === this.search) {
        this.page = 1;
        this.searchThread();
      }
    },
    addThread: function(data) {
      if (data && data.data !== 'multiple') {
        this.$router.push('/admin/conversations/thread/' + data.data.id);
      } else {
        this.threadForm = false;
        this.notification.color = 'success';
        this.notification.text =
          data && data.count
            ? `Mensaje enviado a ${data.count} ${data.count === 1 ? 'cliente' : 'clientes'}`
            : 'Mensajes enviados con éxito';
        this.notification.snackbar = true;
        this.searchThread();
      }
    },
    toggleToManage(thread) {
      this.togglingToManage = thread.id;
      ThreadAPI.changeThreadToManage(thread.id, !thread.to_manage)
        .then(response => {
          thread.to_manage = response.data.data.to_manage;
          // Con el filtro activo, la que se desmarca deja de pertenecer al listado
          if (this.toManage && !thread.to_manage) {
            this.searchThread();
          }
        })
        .catch(() => {})
        .then(() => {
          this.togglingToManage = null;
        });
    },
    restoreFilters() {
      this.$store.dispatch('adminConv/resetParams');
    },
    applySavedFilters(saved) {
      this.$store.dispatch('adminConv/applySavedFilters', saved);
    },
    notify(color, text) {
      this.notification.color = color;
      this.notification.text = text;
      this.notification.snackbar = true;
    },
  },
  watch: {
    clavedat: function(val, oldVal) {
      this.searchThread();
    },
    myCustomers: function(val, oldVal) {
      console.log({ MYCUSTOMERS: val });
      // this.params.myCustomers = val;
      // this.page = 1;
      this.searchThread();
    },
    customers: {
      handler: function(val, oldVal) {
        console.log(val);
        // this.params.users = val;
        // this.page = 1;
        this.searchThread();
      },
      deep: true,
    },
    categories: {
      handler: function(val, oldVal) {
        console.log(val);
        // console.log(val);
        // this.params.categories = val;
        // this.page = 1;
        this.searchThread();
      },
      deep: true,
    },
    status: function(val, oldVal) {
      console.log(val);
      // this.params.status = val;
      // this.page = 1;
      this.searchThread();
    },
    search: function(val, oldVal) {
      if (val.length > 3 || oldVal.length > val.length) {
        // console.log(val);
        const component = this;
        setTimeout(() => {
          component.searchIfStop(val);
        }, 500);
      }
    },
    page: function(val, oldVal) {
      // this.params.page = val;
      console.log(val);

      this.searchThread();
    },
    read: function(val, oldVal) {
      console.log(val);
      this.searchThread();
    },
    unreadMessages: function(val, oldVal) {
      console.log(val);
      this.searchThread();
    },
    premiumUsers: function(val, oldVal) {
      this.searchThread();
    },
    toManage: function() {
      this.searchThread();
    },
    searchMessages: function() {
      // Sin texto que buscar el interruptor no cambia el resultado
      if (this.search) {
        this.searchThread();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.og-select-category {
  max-width: 500px;
}

.og-select-status {
  flex: 0 0 150px;
}

.og-search-messages {
  flex: 0 0 auto;
}

.og-thread-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>

<style lang="scss">
.og-thread-list {
  .v-list__tile {
    height: 100% !important;
  }
}
.to-manage-thread {
  border-left: 5px solid #673ab7;
}
.admin-thread-notification-badge {
  .v-badge__badge {
    right: 15px !important;
  }
}
</style>
